import script from "./InquiryFlowApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryFlowApp.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryFlowApp.vue?vue&type=style&index=0&id=6b1589f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1589f2"]])

export default __exports__